(function ($) {
    /**
     * initializeBlock
     *
     * Adds custom JavaScript to the block HTML.
     *
     */
      $(".company-swiper").each(function () {

        let companySwiper;
        const el = $(this)[0];
        const options = {
          loop: false,
          autoHeight: false,
          slidesPerView: 1.2,
          spaceBetween: 20,
          breakpoints: {
            // when window width is >= 480px
            480: {
              slidesPerView: 3.2,
              spaceBetween: 0
            },
          },
          watchOverflow: true,
        scrollbar: {
            el: ".swiper-scrollbar",
            draggable: true,
          },
          on: {
            transitionStart: function () {
              $("html, body").addClass("overflow-hidden");
            },
            transitionEnd: function () {
              $("html, body").removeClass("overflow-hidden");
            },
          },
        };
  
        companySwiper = new Swiper(el, options);
       
      });
  
  })(jQuery);
  